import { RealTimeAction } from '@/_core/fluxstore/types';
import { RestoreDeletedCardResult } from '../../api/commands';
import { StorymapState } from '../types';
import { mergeRestoredCardsFromTrash } from './trash/mergeRestoredCardsFromTrash';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class RestoreDeletedCardReceived extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RestoreDeletedCardReceived';

    public constructor(public result: RestoreDeletedCardResult) {
        super(RestoreDeletedCardReceived.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: RestoreDeletedCardReceived): void => {
    mergeRestoredCardsFromTrash(state, action.result?.NextGenRestoredCards);
    removeTrashRow(state, action.result?.RestoredCardId);
};

const removeTrashRow = (state: StorymapState, rowId: string): void => {
    if (!rowId) {
        return;
    }

    state.trashState.rows = state.trashState.rows.filter((x) => x.id !== rowId);
    if (state.trashState.selectedRowId === rowId) {
        state.trashState.selectedRowId = null;
    }
};

//@ts-ignore
registerReducer(RestoreDeletedCardReceived.ACTION_TYPE, reducer);
